import { TimeFormat } from '@instinet-analytics/core-lib';
import {
    LiquiditySummaryData,
    LiquiditySummaryItem,
} from '../liquiditySummaryData';

export enum LiquiditySummaryGridRowType {
    PredictedRemaining,
    PredictedClose,
    ActualVolume,
    Adv,
    HistoricalOpen,
    HistoricalClose,
}

export interface LiquiditySummaryGridRow extends LiquiditySummaryItem {
    type: LiquiditySummaryGridRowType;
    label: string;
}

export function getGridData(
    data: LiquiditySummaryData | undefined,
    timeFormat: TimeFormat
): LiquiditySummaryGridRow[] {
    const ret: LiquiditySummaryGridRow[] = [];

    ret.push({
        type: LiquiditySummaryGridRowType.PredictedRemaining,
        label: 'Predicted Remaining',
        ...data?.stats.predictedRemaining,
    });

    if (data?.stats.predictedClose) {
        ret.push({
            type: LiquiditySummaryGridRowType.PredictedClose,
            label: 'Predicted Close',
            ...data?.stats.predictedClose,
        });
    }

    ret.push({
        type: LiquiditySummaryGridRowType.ActualVolume,
        label:
            'Actual Volume till ' +
            timeFormat.toTimeMinutes(new Date().getTime()),
        ...data?.stats.actualVolume,
    });

    ret.push({
        type: LiquiditySummaryGridRowType.Adv,
        label: 'ADV Full Day',
        ...data?.stats.adv,
    });

    ret.push({
        type: LiquiditySummaryGridRowType.HistoricalOpen,
        label: 'Historical Open',
        ...data?.stats.historicalOpen,
    });

    ret.push({
        type: LiquiditySummaryGridRowType.HistoricalClose,
        label: 'Historical Close',
        ...data?.stats.historicalClose,
    });

    for (const row of ret) {
        if (row.orderLeaves !== undefined) {
            row.orderLeaves = Math.abs(row.orderLeaves);
        }
        if (row.fullOrder !== undefined) {
            row.fullOrder = Math.abs(row.fullOrder);
        }
    }

    return ret;
}
